import gql from 'graphql-tag'

export const RefetchUserData = gql`
    mutation RegenerateUserData($input: RegenerateUserDataInput!) {
        regenerateUserData(input: $input) {
            from
            to
            fiatConnectionsCount
            cryptoCredentialsCount
        }
    }
`

export const DeleteUserData = gql`
    mutation DeleteUserData($userId: String!, $deleteType: DeleteType!) {
        deleteUserData(userId: $userId, deleteType: $deleteType)
    }
`

export const GetPreQualificationData = gql`
    query getPreQualificationData($userId: String) {
        getPreQualificationData(userId: $userId) {
            totalNetWorth
            totalDebt
            totalCryptoWorth
            monthlyIncome
            freeCashFlow
            debtToIncomeRatio
            preQualified
            totalAssets
        }
    }
`
